import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AssetsService } from '../../assets.service';

export interface AssetSelectionDialogData {
  scheduleId: number;
  currentAssetId?: number;
  assetTypes?: string[];
}

interface Asset {
  id: number;
  name: string;
  type?: string;
  status?: string;
}

@Component({
  selector: 'lohi-asset-selection-dialog',
  templateUrl: './asset-selection-dialog.component.html',
  styleUrls: ['./asset-selection-dialog.component.scss'],
})
export class AssetSelectionDialogComponent implements OnInit {
  public assets: Asset[] = [];
  public selectedAssetId: number | null = null;
  public loading = false;

  constructor(
    public dialogRef: MatDialogRef<AssetSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AssetSelectionDialogData,
    private assetsService: AssetsService,
  ) {}

  public ngOnInit(): void {
    this.loadAssets();
  }

  public async loadAssets(): Promise<void> {
    this.loading = true;
    try {
      const response = await this.assetsService.getAvailableAssets(this.data.assetTypes);
      this.assets = response.data || [];
      console.log('qwe', response);
      // Preselect current asset if any
      if (this.data.currentAssetId) {
        this.selectedAssetId = this.data.currentAssetId;
      }
    } catch (error) {
      console.error('Failed to load assets', error);
    } finally {
      this.loading = false;
    }
  }

  public onAssetSelection(assetId: number): void {
    this.selectedAssetId = assetId;
  }

  public onCancel(): void {
    this.dialogRef.close();
  }

  public onConfirm(): void {
    if (this.selectedAssetId) {
      this.dialogRef.close({
        scheduleId: this.data.scheduleId,
        assetId: this.selectedAssetId,
      });
    }
  }

  public trackByAssetId(index: number, asset: Asset): number {
    return asset.id;
  }
}
